import axios from "axios";
import PatientsSearchComponent from "../../VeinsTracker/PatientsSearchComponent.vue";

export default {
  name: "LobbyDisplay",
  components: { PatientsSearchComponent },

  data() {
    return {
      //loader
      loader: "",
      //Timer
      TimerObject: {},
      allRawPatients: [],
      allFilterPatients: [],
      stagesSteps: [],
      initDate_1: "",
      stageId:0,

      // Actives
      aSingleStage: "",
      activeStageNdx: 0,

      // Inits
      dateInitValStr: this.dateInitValue(),
      startDate: "",
      endDate: "",
      //-- pagination
      totalRecords: 0,
      pagerows: 10,
      pageSize: 50,
      pageNumber: 1,

      filterObj: {
        externalid: "",
        vid: "",
        firstname: "",
        lastname: "",
        phone: "",
        sdate: "",
        startDate: "",
        endDate: "",
        refreshData: false,
      },

      sortColumn: 0,
      sortColumnOption: 0,

      searchFilter:'',
    };
  }, // data

  // methods
  methods: {
    SearchDataTable() {
      const tar = this.searchFilter.toLowerCase();
      this.allFilterPatients = this.allRawPatients.filter(f=>f.firstName.toLowerCase().includes(tar ) || f.lastName.toLowerCase().includes(tar));
     //debugger
    },

    applySearchClick(val) {
      this.pageNumber = 1;
      this.loadInit();
      //if(!this.filterObj.refreshData) return;
    },

    //code for Data-Tables_
    pageChange(obj) {
      if (obj == "Next") {
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.StageId = this.stageId;
      this.dummyComm.filter = this.filter;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/StageDispInitData_1";
      this.axiosGetData(url, this.dummyComm, 1);
    },
    orderBy(column) {
      if (this.sortColumn == column) {
        switch (this.sortColumnOption) {
          case 0:
            this.sortColumnOption = 1;
            break;
          case 1:
            this.sortColumnOption = 2;
            break;
          case 2:
            this.sortColumn = 0;
            this.sortColumnOption = 0;
            break;
        }
      } else {
        this.sortColumn = column;
        this.sortColumnOption = 1;
      }
      this.pageNumber = 1;
      this.loadInit();
    },
    onPage(e) {
      this.pagerows = e.rows;
      this.intDummyComm();
      this.dummyComm.stageId = this.aSingleStage.stageId;
      this.dummyComm.pageNumber = e.page;
      this.dummyComm.pageSize = this.pagerows;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/StageDispInitData";
      this.refreshPaginationData(url, this.dummyComm);
    },
    async refreshPaginationData(myUrl, myData) {
      let data = "err";
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        contentType: "application/json",
        dataType: "json",
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          if (res.data.dc.auditFlag === 1) {
            this.stagesSteps = res.data.stageSteps;
            this.allRawPatients = res.data.patients;
            for (let i = 0; i < res.data.patients.length; i++) {
              this.allRawPatients[i] = res.data.patients[i];
              this.allRawPatients[i].dosStr1 =
                this.allRawPatients[i].dos.split("T")[0];
              this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                .split("-")[0]
                .substring(2, 4);
              this.allRawPatients[i].dosStr1 =
                this.allRawPatients[i].dosStr1.split("-")[1];
              if (this.allRawPatients[i].dosStr1.length == 1) {
                this.allRawPatients[i].dosStr1 =
                  "0" + this.allRawPatients[i].dosStr1;
              }
            }
            //this.baseStagesSteps = res.data.baseStagesSteps;
            if (this.activeStageNdx < 0) {
              this.stepsInStagesForTable = this.stagesSteps[0].steps;
            } else
              this.stepsInStagesForTable =
                this.stagesSteps[this.activeStageNdx].steps;
            this.stepRes = res.data.stepRes;
            this.stageRes = res.data.stageRes;
          }
          loader.hide();
        })
        .catch(function (err) {
          loader.hide();
        })
        .finally(() => {
          loader.hide();
        });
      return data;
    },

    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    stepText(pat) {
      if (pat.stageSteps[this.activeStageNdx].status === "") {
        return "Yet To Be Acknowledge";
      } else {
        const obj = pat.stageSteps[this.activeStageNdx].steps;
        let started = false;
        let str = "";
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].status !== "") {
            if (!started) started = true;
            str += "<b>" + obj[i].stepName + "</b>:" + obj[i].status + ", ";
          }
        }
        if (str.length > 0) {
          str = str.substring(0, str.length - 2);
          str = "<p>" + str + "</p>";
        }
        if (!started) return "Yet To Be Acknowledge";
        else return str;
      }
      //console.log(pat);
    },

    stageClick(ndx, val) {
      if (this.activeStageNdx == ndx) return;
      try {
        // if (this.stagesSteps[ndx].steps.length < 1) {
        //   this.ShowErrorAutoClose("Stage has no steps.");
        //   return;
        // }
        // else {
          this.loadInit();
        this.dummyComm.StageId = this.stagesSteps[ndx].stageId;
        this.stageId = this.dummyComm.StageId;
        this.aSingleStage = JSON.parse(JSON.stringify(this.stagesSteps[ndx]));
        this.stepsInStagesForTable = this.stagesSteps[ndx].steps;
        this.activeStageNdx = ndx;
        if (val == -1) {
          //this.pageChange(1);
        }
      } catch {
        //this.loadInit();
        this.calcTimerRoutine();
      } finally {
        this.calcTimerRoutine();
      }
      this.filterLobbyByStage();
      //console.log(this.allFilterPatients);
      //this.updatePatientResources();
    },
    // ~~calcTimer
    calcTimerRoutine() {
      for (let i = 0; i < this.allFilterPatients.length; i++) {
        const pat = this.allFilterPatients[i];
        let found = false;
        for (let j = 0; j < pat.stageSteps.length; j++) {
          if (pat.stageSteps[j].stageId == this.aSingleStage.stageId)
            pat.stage.alert = pat.stageSteps[j].stageTimeLimit;
          if (pat.stageSteps[j].status !== "") {
            found = true;
            break;
          }
        }
        if (found) {
          pat.stage.isStageActive = true;
          for (let j = 0; j < pat.stageSteps.length; j++) {
            if (pat.stageSteps[j].stageId == this.aSingleStage.stageId) {
              for (let k = 0; k < pat.stageSteps[j].steps.length; k++) {
                let obj = pat.stageSteps[j].steps[k];
                if (obj.status == 1) {
                  // if is active
                  const startTime = new Date(obj.stepStartTime);
                  const dd = new Date();
                  const diff = Math.abs(dd - startTime);
                  const xx = Math.floor(diff / 1000 / 60);
                  let seconds = Math.floor(diff / 1000);
                  let minutes = Math.floor(seconds / 60);
                  let hours = Math.floor(minutes / 60);
                  let days = Math.floor(hours / 24);
                  hours = hours - days * 24;
                  minutes = minutes - days * 24 * 60 - hours * 60;
                  seconds = seconds % 60;
                  obj.timeElapsed =
                    ("00" + days).slice(-2) +
                    ":" +
                    ("00" + hours).slice(-2) +
                    ":" +
                    ("00" + minutes).slice(-2) +
                    ":" +
                    ("00" + seconds).slice(-2);
                  // if(obj.alertDays == 0 && alertMins == 0 && alertHours == 0){obj.isStepOverdue = false;}
                  if (xx > obj.stepTimeLimit && obj.stepTimeLimit > 0) {
                    //console.log("**poi: ", xx, obj.stepTimeLimit);
                    obj.isStepOverdue = true;
                    obj.stepOverdueTime = xx;
                  } else obj.isStepOverdue = false;
                }
              }
            }
          }
        } else {
          pat.stage.isStageActive = false;
          const dos = new Date(pat.dos);
          const dd = new Date();
          const diff = Math.abs(dd - dos);
          pat.stage.isStageoverdue = Math.floor(diff / 1000 / 60);
          // const res=document.querySelectorAll("[id*=pttt-");
        }
      }
      for (let i = 0; i < this.allFilterPatients.length; i++) {
        // stage overdue
        const pat = this.allFilterPatients[i].stage;
        pat.isStageoverdue = false;
        if (pat.startTime instanceof Date && pat.alert > 0) {
          const dd = new Date();
          const start = this.dateAdd(pat.startTime, "m", pat.alert);
          const diff = Math.abs(dd - start);
          if (diff < 0) pat.isStageoverdue = Math.floor(diff / 1000 / 60);
        }
        // patient saved -- new id assigned
        // this.allFilterPatients[i].mainButtonClass = "btn btn-danger";
        // if (this.allFilterPatients[i].patientId > 0) {
        //   if (this.allFilterPatients[i].isNew > 0){
        //     this.allFilterPatients[i].mainButtonClass = "btn btn-warning";}
        //   else
        //   {this.allFilterPatients[i].mainButtonClass = "btn btn-success";}
        // }
      }
      //this.updatePatientResources();
    },

    filterLobbyByStage() {
      this.allFilterPatients = this.allRawPatients;
      const obj = this.allFilterPatients;
      this.allFilterPatients = [];
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].currentStage == this.aSingleStage.stageId)
          this.allFilterPatients.push(obj[i]);
      }
    },

    tabPageClass(ndx) {
      if (this.activeStageNdx === ndx) return "nav-link active";
      else return "nav-link";
    },

    searchMainList() {
      if (this.startDate != "" && this.endDate != "") {
        this.allFilterPatients = this.allRawPatients.filter(
          (f) =>
            +new Date(f.dos) >= +new Date(this.startDate) &&
            +new Date(f.dos) <= +new Date(this.endDate)
        );
      }
    },

    dateInitValue() {
      //   const dd = new Date();
      //   const str =
      //     dd.getMonth() + 1 + "/" + dd.getDate() + "/" + dd.getFullYear();
      //return str + " - " + str;
      return "";
      //  "01/01/2018 - 01/15/2018"
    },

    datePickerChange(startDate, endDate) {
      this.allFilterPatients = this.allRawPatients.filter(
        (f) => f.dos >= startDate && f.dos <= endDate
      );

      const dd1 = new Date(startDate);
      const dd2 = new Date(endDate);

      const str1 =
        dd1.getMonth() + 1 + "/" + dd1.getDate() + "/" + dd1.getFullYear();
      const str2 =
        dd2.getMonth() + 1 + "/" + dd2.getDate() + "/" + dd2.getFullYear();

      this.dateInitValStr = str1 + " - " + str2;
    },

    datePicker() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDate = new Date(start);
          self.endDate = new Date(end);
          self.initDate_1 =
            self.dateToMDY(self.startDate) +
            " - " +
            self.dateToMDY(self.endDate);
        }
      );
    },

    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },

    loadInit() {
      // this.endDate = new Date();
      // this.startDate = new Date();
      // this.startDate.setDate(this.startDate.getDate() - 7);
      // this.initDate_1 =
      //   this.dateToMDY(this.startDate) + " - " + this.dateToMDY(this.endDate);

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.extras1 = "";
      // this.dummyComm.pageNumber = 1;
      // this.dummyComm.pageSize = this.pagerows;
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      if(this.aSingleStage) this.dummyComm.stageId = this.aSingleStage.stageId;
      else this.dummyComm.StageId=0;
      this.dummyComm.filter = "";
      let stageId = 0;
      if(this.aSingleStage) stageId = this.aSingleStage.stageId;

      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
        stageId: stageId,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/StageDispInitData_1";
      this.axiosGetData(url, myData, 1);
      this.StartLogoutTime();
    },
    loadInitWithoutLoad() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";
      let stageId = 0;
      if(this.aSingleStage) stageId = this.aSingleStage.stageId;

      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
        stageId: stageId,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/StageDispInitData_1";
      this.axiosGetData(url, myData, 6);
      this.StartLogoutTime();
    },

    //-------------------- Common Methods
    async axiosGetData(myUrl, myData, what) {
      if (what !== 6) {
        var loader = this.$loading.show({
          color: "#03a9f3",
        });
      }
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          // if everything goes well -- we will get data
          if (what === 1) {
            $("#v-" + myData.visitId + "").prop("disabled", false);
            this.stagesSteps = res.data.stageSteps;
            if (res.data.dc.auditFlag === 1) {
              this.myData = res.data;
              this.totalPages = res.data.dc.totalPages;
              this.totalRows = res.data.dc.totalRow;
              this.allRawPatients = res.data.patients;
              for (let i = 0; i < res.data.patients.length; i++) {
                this.allRawPatients[i] = res.data.patients[i];
                this.allRawPatients[i].dosStr1 =
                  this.allRawPatients[i].dos.split("T")[0];
                this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                  .split("-")[0]
                  .substring(2, 4);
                this.allRawPatients[i].dosStr1 =
                  this.allRawPatients[i].dosStr1.split("-")[1];
                if (this.allRawPatients[i].dosStr1.length == 1) {
                  this.allRawPatients[i].dosStr1 =
                    "0" + this.allRawPatients[i].dosStr1;
                }
              }
              this.baseStagesSteps = res.data.baseStagesSteps;
              if (this.activeStageNdx < 0) {
                this.stepsInStagesForTable = this.stagesSteps[0].steps;
              }
              this.stepRes = res.data.stepRes;
              //this.stageRes = res.data.stageRes;
              this.operators = res.data.operators;
              //this.gFillUserInfo(this.operators);
            }
          } else if (what === 6) {
            this.stagesSteps = res.data.stageSteps;
            if (res.data.dc.auditFlag === 1) {
              this.myData = res.data;
              this.totalPages = res.data.dc.totalPages;
              this.totalRows = res.data.dc.totalRow;
              this.allRawPatients = res.data.patients;
              for (let i = 0; i < res.data.patients.length; i++) {
                this.allRawPatients[i] = res.data.patients[i];
                this.allRawPatients[i].dosStr1 =
                  this.allRawPatients[i].dos.split("T")[0];
                this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                  .split("-")[0]
                  .substring(2, 4);
                this.allRawPatients[i].dosStr1 =
                  this.allRawPatients[i].dosStr1.split("-")[1];
                if (this.allRawPatients[i].dosStr1.length == 1) {
                  this.allRawPatients[i].dosStr1 =
                    "0" + this.allRawPatients[i].dosStr1;
                }
              }
              this.baseStagesSteps = res.data.baseStagesSteps;
              if (this.activeStageNdx < 0) {
                this.stepsInStagesForTable = this.stagesSteps[0].steps;
              }
              this.stepRes = res.data.stepRes;
              this.stageRes = res.data.stageRes;
              this.operators = res.data.operators;
              //this.gFillUserInfo(this.operators);
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
          //this.datePicker();
          //this.calcTimerRoutine();
        });
    }, // axiosGetData
  }, // methods

  mounted() {
    clearTimeout(this.loadObj);
    this.loadInit();
    window.setInterval(() => {
      this.loadInitWithoutLoad();
    }, 90000);
  }, // mounted
  unmounted() {
    clearTimeout(this.TimerObject);
  },

  watch: {
    allRawPatients: function () {
      try {
        for (let i = 0; i < this.allRawPatients.length; i++) {
          const dd = new Date(this.allRawPatients[i].dos);
          this.allRawPatients[i].dos = new Date(this.allRawPatients[i].dos);
          this.allRawPatients[i].dosdate = dd.toLocaleDateString();
          this.allRawPatients[i].dostime = dd.toLocaleTimeString();
          //this.allRawPatients[i].dosForSearch = dd.toDateString();

          const ddd = new Date(this.allRawPatients[i].dob);
          this.allRawPatients[i].dob = ddd.toLocaleDateString();
        }
        //this.stageClick(0);
        //this.searchMainList();
      } catch {
        /**/
      } finally {
        this.allFilterPatients = this.allRawPatients;
        this.searchMainList();
        //   this.$nextTick(() => {
        //   $("#home_2").DataTable().destroy();
        //   $("#home_2").DataTable({
        //       buttons: [
        //               'copy', 'csv', 'excel', 'pdf', 'print'
        //       ]
        //     });
        //     $('.buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel').addClass('btn btn-primary mr-1');
        //   $(".home_2").DataTable().draw();
        // });
      }
    },

    startDate: function () {
      this.searchMainList();
    },
    endDate: function () {
      this.searchMainList();
    },
  }, // watch
};

